<template>
  <div class="myLight_wrap english_container">
    <myHeader />
    <!-- 首页广告模块 -->
    <div class="lighting_banner">
      <div class="lighting_banner_img">
        <img
          src="https://download.hecoos.com/enlightv/2025-17/8298062e074abc9f671d63489b88be82.jpg"
          alt=""
          :style="{ clip: 'rect(0, ' + leftClipWidth + 'px, auto, 0)' }"
        />
        <img
          src="https://download.hecoos.com/enlightv/2025-17/7315d1ddc0075ebea4e3079ab2191629.jpg"
          alt=""
          :style="{ clip: 'rect(0, auto, auto, ' + leftClipWidth + 'px)' }"
        />
      </div>
      <div
        class="twentytwenty-handle"
        :style="{ left: leftClipWidth + 'px' }"
        @mousedown="startDragging"
      ></div>
    </div>

    <!-- 灯光设计模块 -->
    <div class="lighting">
      <canvas id="lighting_canvas"></canvas>
      <div class="lighting_content">
        <p
          style="
            font-size: 80px;
            color: rgb(255, 255, 255);
            font-weight: 900;
            height: auto;
          "
          class="wow fadeInUp enProductTitle"
        >
          Lighting design
        </p>
        <p
          class="wow fadeInUp enTwoProductDesc"
          style="
            margin: 10px auto 0px;
            width: 945px;
            height: 144px;
            visibility: visible;
            animation-name: fadeInUp;
          "
        >
          Whether it's simulating lighting effects, pre-programming, or
          controlling actual fixtures, hecoos provides lighting designers with
          an efficient and creative workflow
        </p>
        <router-link
          id="lighting_design_contact_us"
          class="callMe"
          :to="{ name: 'enCaseDemonstration', hash: '#specific-position' }"
          >Contact Us</router-link
        >
      </div>
    </div>

    <!-- 先刷重点模块 -->
    <div class="key_points">
      <p class="wow fadeInUp enProductTitle">Highlight the Key Elements</p>
      <p
        style="
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 60px;
          color: rgba(255, 255, 255, 0.64);
        "
        class="wow fadeInUp"
      >
        Advantages of Lighting Design
      </p>
      <img
        v-show="isFirstImage1"
        style="width: 1090px; height: 569px"
        src="https://download.hecoos.com/enlightv/2025-35/eb75ecb23a2a4b44ba9516bb84c9520d.jpg"
        alt=""
      />
      <img
        v-show="isFirstImage2"
        style="width: 1090px; height: 569px"
        src="https://download.hecoos.com/enlightv/2025-35/e024d97b129ce0214f19647e1f7dd820.jpg"
        alt=""
      />
      <img
        v-show="isFirstImage3"
        style="width: 1090px; height: 569px"
        src="https://download.hecoos.com/enlightv/2025-35/39622fe1143bbb20cd3f46fd67e5e308.jpg"
        alt=""
      />
      <div class="button_container">
        <div class="button_list" ref="button_list">
          <button
            :class="{ btn: true, active: isBtn1Active }"
            @click="switchContent(1)"
          >
            Lighting Simulation and Pre-Programming
          </button>
          <button
            :class="{ btn: true, active: isBtn2Active }"
            @click="switchContent(2)"
          >
            Real-time Dynamic Adjustment
          </button>
          <button
            :class="{ btn: true, active: isBtn3Active }"
            @click="switchContent(3)"
          >
            Compatibility and Integration
          </button>
        </div>
        <div
          class="underline"
          :style="{
            width: buttonUnderlineWidth + 'px',
            left: buttonUnderlineLeft + 5 + 'px',
          }"
        ></div>
      </div>
      <div class="text enProductCont">
        <p v-show="isFirstImage1" class="wow fadeInUp">
          Step into the world of Hecoos, where you can add lighting equipment
          for real-time preview of design concepts, independently edit lighting
          library files, assign address codes, and achieve precise control based
          on protocols—smoothly and seamlessly.
        </p>
        <p v-show="isFirstImage2" class="wow fadeInUp">
          Even with pre-programmed lighting effects, lighting designers can
          intervene in response to unexpected changes during the event, quickly
          adapting to on-site demands to ensure the best possible visual
          outcome.
        </p>
        <p v-show="isFirstImage3" class="wow fadeInUp">
          By integrating control protocols such as DMX512 and Art-Net, hecoos
          provides full control over stage lighting, film lighting, LED strips,
          and other lighting fixtures.
        </p>
      </div>
    </div>

    <!-- 应用场景模块 -->
    <div class="scene">
      <p class="wow fadeInUp enProductTitle">Application Scenarios</p>
      <p
        style="
          font-size: 24px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.64);
        "
        class="wow fadeInUp"
      >
        Practical Applications of Lighting Design
      </p>
      <myBanner
        :applicationInfo="applicationInfo"
        class="wow fadeInUp"
      ></myBanner>
    </div>

    <!-- 产品模块 -->
    <div class="product colorBlack">
      <div class="tab">
        <p class="wow fadeInUp enProductTitle" style="margin-bottom: 0px">
          Product
        </p>
        <p class="wow fadeInUp enProductTitle">Your Lighting Toolkit</p>
        <div class="switch">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <div class="switch_list" ref="switch_list">
            <span
              v-for="item in switchList"
              @click="selectTab(item.value)"
              v-text="item.title"
              :key="item.value"
            ></span>
          </div>
          <div
            class="underline"
            :style="{
              width: underlineWidth + 'px',
              left: underlineLeft + 'px',
            }"
          ></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="projection_content">
          <div class="studio" v-show="showContents[0]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/a4beea54e9867e8ffcdf6a151c966e1d.png"
                alt=""
                class=""
              />
              <div class="textContent">
                <p class="enProductTitle" style="margin-bottom: 55px;">
                  hecoos Lighting
                </p>
                <p class="enProductCont"  style="margin-bottom: 40px;">
                  hecoos Lighting seamlessly adapts to a wide range of lighting
                  fixtures used in stage performances, film production,
                  architectural lighting, commercial spaces, and art
                  exhibitions. The "design is realization" philosophy is
                  reflected throughout the Hecoos Lighting workflow, providing
                  lighting designers with ample creative freedom.
                </p>
                <router-link class="call_more" to="/en/hecoosLighting"
                  >Learn more</router-link
                >
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[1]">
            <div class="layout">
              <img
                style="width: 900px; height: 430px"
                src="https://download.hecoos.com/enlightv/2025-17/fdb25e23aa3f7ee931dde2f6d7adc9f3.png"
                alt=""
                class=""
              />
              <div class="textContent">
                <p  class="enProductTitle" style="margin-bottom: 55px;">
                  hecoos Studio
                </p>
                <p class="enProductCont"  style="margin-bottom: 70px;">
                  Bring your vision to life. hecoos is a new media production
                  software that allows you to preview real-world scenarios in
                  advance.
                </p>
                <router-link class="call_more" to="/en/studio"
                  >Learn more</router-link
                >
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[2]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/b829a8b649c5d90617bc7ba860f34c24.png"
                alt=""
                class=""
              />
              <div class="textContent">
                <p  class="enProductTitle" style="margin-bottom: 55px;">
                  hecoos Server-D
                </p>
                <p class="enProductCont"  style="margin-bottom: 100px;">
                  Relying on the Hecoos workflow, every stage from conceptual
                  inspiration to final execution is meticulously controlled,
                  embodying the product design philosophy that "design is
                  realization.
                </p>
                <router-link
                  class="call_more"
                  :to="{ path: '/en/mediaServer?section=0', hash: '#tab' }"
                  >Learn more</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 创意模块 -->
    <Creativity :imgUrl="imgUrl" />
    <myFooter />
    <BackToTop />
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader.vue";
import myFooter from "@/components/en_pc/myFooter.vue";
import Creativity from "@/components/en_pc/creativity";
import myBanner from "@/components/en_pc/myBanner";
import BackToTop from "@/components/en_pc/BackToTop";
import setupCanvas from "@/utils/lighting_canvas.js";
export default {
  data() {
    return {
      isFirstImage1: true,
      isFirstImage2: false,
      isFirstImage3: false,
      // 用于控制按钮的激活状态
      isBtn1Active: true,
      isBtn2Active: false,
      isBtn3Active: false,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      imgUrl:
        "https://download.hecoos.com/enlightv/2025-17/15ee7aebaec0c2d6bb4d5437a737c89d.png",
      switchList: [
        { value: 0, title: "Lighting" },
        { value: 1, title: "Studio" },
        { value: 2, title: "Server-D" },
      ],
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      applicationInfo: [
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/b15f1b9fefbc87efb8c1b0e67967b6b1.png",
          title: "Media Facade",
          msg: "Pixel-level planning of each lamp on the building facade, using the lamp as a screen and presenting animations with the lights.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/18a6389f4267011b6e63b29903d0bd00.png",
          title: "Art Installation",
          msg: "Unified control of various lamps enables the realization of creative works to be carried out more smoothly.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/9c27479528f5da44efd94c11baecfe86.png",
          title: "Virtual Shooting",
          msg: "Unifying virtual and physical lighting control in real-time rendering engines to achieve pixel-accurate environmental fidelity.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/1ad3e2e075c074ca3b40146bbfd2ac35.png",
          title: "Theme Park",
          msg: "Automation of scene orchestration, hecoos' all-weather lighting management, and maintenance operations will no longer be difficult.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/75ed3bc23bdc692c81c1e959c072493a.png",
          title: "Brand Promotion Activities",
          msg: "The pre-editing of the light show enables the on-site execution to only require minor adjustments to restore the design, significantly reducing the on-site debugging pressure.",
        },
      ],

      leftClipWidth: 0,
      isDragging: false,
      containerWidth: 0,

      underlineWidth: 0,
      underlineLeft: 0,

      currentButtonIndex: 1,
      buttonUnderlineWidth: 0,
      buttonUnderlineLeft: 0,
    };
  },
  components: {
    myHeader,
    myFooter,
    Creativity,
    myBanner,
    BackToTop,
  },
  mounted() {
    this.containerWidth = this.$el.querySelector(
      ".lighting_banner_img"
    ).offsetWidth;
    this.leftClipWidth = this.containerWidth / 2;
    // 灯光设计canvas调用
    setupCanvas("lighting_canvas");
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      this.buttonUpdateUnderlinePosition();
      this.buttonSetupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
      window.addEventListener("resize", this.buttonUpdateUnderlinePosition);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener("resize", this.buttonUpdateUnderlinePosition);
    window.removeEventListener("mousemove", this.handleDrag);
    window.removeEventListener("mouseup", this.stopDragging);
  },
  methods: {
    // 轮播图效果
    startDragging(event) {
      this.isDragging = true;
      this.containerWidth = event.target.parentElement.offsetWidth;
      window.addEventListener("mousemove", this.handleDrag);
      window.addEventListener("mouseup", this.stopDragging);
    },
    handleDrag(event) {
      if (this.isDragging) {
        const newLeft =
          event.clientX -
          event.target.parentElement.getBoundingClientRect().left;
        this.leftClipWidth = Math.min(
          Math.max(0, newLeft),
          this.containerWidth
        );
      }
    },
    stopDragging() {
      this.isDragging = false;
      window.removeEventListener("mousemove", this.handleDrag);
      window.removeEventListener("mouseup", this.stopDragging);
    },

    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },

    // 导航切换底部跟随
    buttonUpdateUnderlinePosition() {
      const switchList = this.$refs.button_list;
      if (switchList) {
        const button =
          switchList.querySelectorAll("button")[this.currentButtonIndex - 1];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = button.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(button);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.buttonUnderlineWidth = spanRect.width + paddingLeft - paddingRight;

        // 计算去除 padding 后的左侧偏移量
        this.buttonUnderlineLeft =
          spanRect.left - switchListRect.left - paddingLeft + paddingRight;
      }
    },
    // 文字宽度变化监听
    buttonSetupSpanResizeObservers() {
      const buttons = this.$refs.button_list.querySelectorAll("button");
      const resizeCallback = () => {
        this.buttonUpdateUnderlinePosition();
      };
      buttons.forEach((button) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(button);
      });
    },

    // 切换内容和按钮激活状态的方法
    switchContent(type) {
      this.currentButtonIndex = type;
      this.buttonUpdateUnderlinePosition();
      if (type === 1) {
        this.isFirstImage1 = true;
        this.isFirstImage2 = false;
        this.isFirstImage3 = false;
        this.isBtn1Active = true;
        this.isBtn2Active = false;
        this.isBtn3Active = false;
      } else if (type === 2) {
        this.isFirstImage1 = false;
        this.isFirstImage2 = true;
        this.isFirstImage3 = false;
        this.isBtn1Active = false;
        this.isBtn2Active = true;
        this.isBtn3Active = false;
      } else {
        this.isFirstImage1 = false;
        this.isFirstImage2 = false;
        this.isFirstImage3 = true;
        this.isBtn1Active = false;
        this.isBtn2Active = false;
        this.isBtn3Active = true;
      }
    },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/xty.scss";
@import "@/styles/optimize_adaptation.scss";
</style>
